import { render, staticRenderFns } from "./articleDetail.vue?vue&type=template&id=6a659fa5&scoped=true"
import script from "./articleDetail.vue?vue&type=script&lang=ts"
export * from "./articleDetail.vue?vue&type=script&lang=ts"
import style0 from "./articleDetail.vue?vue&type=style&index=0&id=6a659fa5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_3bbe12a2a332147dfeceaba3e069e538/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a659fa5",
  null
  
)

export default component.exports